export enum ChecklistAnswerClassType {
  Canvas = 33,
  Numeric = 34,
  SingleChoice = 35,
  Text = 36,
  Html = 40
}